exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "hr {\n  height: 1px;\n  /* Set the hr color */\n  color: rgb(204, 204, 204); /* old IE */ /* Modern Browsers */\n}[dir] hr {\n  margin-top: 2px;\n  border: none;\n  background-color: rgb(204, 204, 204);\n}\n.popup90 .vs-popup {\n  width: 90% !important;\n}\n.vue_select_drop_size_160 .vs__dropdown-menu {\n  max-height: 160px;\n}\n", ""]);

// exports
